export const makeSelectLocations = (state: AppState) => state.locationReducer.locations;

export const makeSelectActiveLocation = (state: AppState) => state.locationReducer.activeLocation;
export const makeSelectCurrentLocation = (state: AppState) => state.locationReducer.currentLocation;

export const makeSelectActiveLocationSummary = (state: AppState) =>
  state.locationReducer.activeLocationSummary;

export const makeSelectLocationQueryOptions = (state: AppState) =>
  state.locationReducer.queryOptions;

export const makeSelectLocationsSimplifiedLoading = (state: AppState) =>
  state.locationReducer.locationsLoadingSimplified;
